<template>
  <div class="container mt-5 mb-md-4 py-5">
    <breadcrumb class="mb-3 mb-md-4 pt-md-3" :crumbs="crumbs"></breadcrumb>

    <!-- Page content -->
    <div class="row justify-content-center pb-sm-2 pt-3">
      <div class="col-lg-6">
        <h1 class="h2 text-center pb-4 mb-3">Reset Your Password</h1>

        <div class="bg-light rounded-3 py-4 px-md-4">

          <form action="post" @submit.prevent="resetPassword">
            <!-- Email -->
            <div class="mb-4">
              <label class="form-label" for="email">Email <span class="text-danger">*</span></label>
              <input v-model="form.email" class="form-control form-control-lg" type="email" id="email"
                     placeholder="Enter your email address" required>
            </div>
            <!-- / Email -->

            <!-- Password -->
            <div class="mb-4">
              <label class="form-label" for="password">New Password <span class="text-danger">*</span></label>
              <input v-model="form.password" class="form-control form-control-lg" type="password" id="password"
                     placeholder="Enter new password" required>
            </div>
            <!-- / Password -->

            <!-- Password Confirmation -->
            <div class="mb-4">
              <label class="form-label" for="password_confirmation">Password Confirmation<span class="text-danger">*</span></label>
              <input v-model="form.password_confirmation" class="form-control form-control-lg" type="password" id="password_confirmation"
                     placeholder="Enter new password confirmation" required>
            </div>
            <!-- / Password Confirmation -->

            <input type="submit" class="d-none"/>

            <div class="actions-wrapper">
              <div class="left">
                <a :class="{'disabled opacity-50': isLoading}"
                   @click.prevent="resetPassword" class="btn btn-primary btn-lg rounded-pill ms-sm-auto" href="#">
                  <spinner v-if="isLoading" class="spinner-border-sm me-2"></spinner>
                  <i v-else class="fi-lock fs-sm me-2"></i>
                  Reset Password</a>
              </div>
              <div class="right">
<!--                <a href="/login">Or login here</a>-->
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
    <!-- / Page content -->
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import Spinner from "../components/Spinner";
import axios from 'axios';
import Forms from "../mixins/Forms";

import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  components: {Breadcrumb, Spinner},
  mixins: [Forms],
  data() {
    return {
      crumbs: [
        {
          href: '/',
          label: 'Home'
        },
        {
          href: '#',
          label: 'Reset Password',
          active: true
        }
      ],
      form: {
        email: '',
        password: '',
        password_confirmation: ''
      },
      isLoading: false
    }
  },
  methods: {
    resetPassword() {
      let vm = this;
      vm.isLoading = true;
      axios.post(window.API_BASE + '/reset-password', {
        email: vm.form.email,
        password: vm.form.password,
        password_confirmation: vm.form.password_confirmation,
        token: vm.$route.query.token
      }).then(() => {
        vm.isLoading = false;
        toast.success('Password reset successfully');
        vm.form.email = '';
        vm.$router.push('/');
      }).catch(e => {
        console.log(e);
        vm.isLoading = false;
        vm.setAndNotifyErrors(e, 'Error resetting password');
      });
    }
  },
  computed: {},
  setup() {

  },
}
</script>


<style scoped lang="scss">
.actions-wrapper {
  display: flex;

  .left {
    flex-grow: 1;
  }

  .right {
    flex-shrink: 1;
    display: flex;
    align-items: center;
  }
}
</style>